import Base from '@studiometa/js-toolkit';

/**
 * Header class.
 */
export default class Overlay extends Base {
  /**
   * Class cofnig
   * @return {Object}
   */
  static config = {
    name: 'Overlay',
    refs: ['logo'],
  };

  /**
   * Wait before page is loaded and first animation is done
   * Then hide the overlay
   * @return {void}
   */
  mounted() {
    // Add the class to start the logo animation
    this.$el.classList.add('overlay--visible');
    // When the logo is visible, hide the overlay
    setTimeout(() => {
      this.animateOut();
    }, 500);
  }

  /**
   * Hide the overlay with a transition
   * @return {void}
   */
  animateOut() {
    // Allow scroll
    document.body.classList.remove('overflow-hidden');

    // Hide the overlay
    this.$el.classList.remove('overlay--visible');
    setTimeout(() => {
      this.$el.classList.add('overlay--hide');
    }, 500);
  }

  /**
   * Show the overlay with a transition
   * @return {void}
   */
  animateIn() {
    // Forbid scroll
    document.body.classList.add('overflow-hidden');

    // Show the overlay
    this.$el.classList.remove('overlay--hide');
    setTimeout(() => {
      this.$el.classList.add('overlay--visible');
    }, 500);
  }
}
